module.exports = __webpack_public_path__ + "static/img/v20.330be60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v20.png
// module id = juhX
// module chunks = 1